import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart-full.svg';
import showNotification from '~/helpers/notification-helper';
export default {
  name: 'Heart',
  props: {
    reference: {
      type: String,
      required: true
    },
    withText: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      mdmUrls: {
        moodboard: '/user/wishlist'
      },
      loading: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    user: 'user/me',
    items: 'wishlist/items'
  }), {
    isInWishlist() {
      return this.includesRef(this.reference);
    },

    btnText() {
      return this.isInWishlist ? this.$t('delete.btn_label') : this.$t('add.btn_label');
    }

  }),
  methods: _objectSpread({}, mapActions({
    fetchWishlist: 'wishlist/fetchWishlistItems',
    addWishlistItem: 'wishlist/addWishlistItem',
    deleteWishlistItem: 'wishlist/deleteWishlistItem'
  }), {
    toggleWishlist(ref, $event) {
      if (this.loading) {
        return;
      }

      this.loading = true;

      if (this.includesRef(ref)) {
        this.removeFromWishlist(ref, $event);
      } else {
        this.addToWishlist(ref, $event);
      }
    },

    includesRef(ref) {
      return Boolean(this.getWishlistItem(ref));
    },

    addToWishlist(ref, $event) {
      var _this = this;

      return _asyncToGenerator(function* () {
        if (!_this.user) {
          _this.loading = false;

          _this.$root.$emit('open-layer', {
            state: true,
            name: 'LoginRegister'
          });

          _this.tracking({
            ref,
            action: 'Add-to-wishlist',
            label: 'not_connected',
            el: $event
          });

          return;
        }

        _this.tracking({
          ref,
          action: 'Add-to-wishlist',
          el: $event
        });

        try {
          yield _this.addWishlistItem(ref);
          yield _this.fetchWishlist();
          showNotification({
            text: _this.$i18n.messages[_this.$store.state.i18n.currentLocale.language].add.subtitle,
            destination: "/".concat(_this.$store.state.i18n.currentLocale.market, "/").concat(_this.$store.state.i18n.currentLocale.language).concat(_this.mdmUrls.moodboard),
            backgroundColor: 'green'
          });
        } catch (e) {
          showNotification({
            text: _this.$i18n.messages[_this.$store.state.i18n.currentLocale.language].add.error,
            destination: "/".concat(_this.$store.state.i18n.currentLocale.market, "/").concat(_this.$store.state.i18n.currentLocale.language).concat(_this.mdmUrls.moodboard),
            backgroundColor: 'red'
          });
        } finally {
          _this.loading = false;
        }
      })();
    },

    removeFromWishlist(ref, $event) {
      var _this2 = this;

      return _asyncToGenerator(function* () {
        if (!_this2.user) {
          _this2.loading = false;

          _this2.$root.$emit('open-layer', {
            state: true,
            name: 'LoginRegister'
          });

          _this2.tracking({
            ref,
            action: 'Remove-from-wishlist',
            label: 'not_connected',
            el: $event
          });

          return;
        }

        _this2.tracking({
          ref,
          action: 'Remove-from-wishlist',
          el: $event
        });

        try {
          const wishlistItem = _this2.getWishlistItem(ref);

          yield _this2.deleteWishlistItem(wishlistItem.reference);
          showNotification({
            text: _this2.$i18n.messages[_this2.$store.state.i18n.currentLocale.language].delete.subtitle,
            destination: "/".concat(_this2.$store.state.i18n.currentLocale.market, "/").concat(_this2.$store.state.i18n.currentLocale.language).concat(_this2.mdmUrls.moodboard),
            backgroundColor: 'green'
          });
        } catch (e) {
          showNotification({
            text: _this2.$i18n.messages[_this2.$store.state.i18n.currentLocale.language].delete.error,
            destination: "/".concat(_this2.$store.state.i18n.currentLocale.market, "/").concat(_this2.$store.state.i18n.currentLocale.language).concat(_this2.mdmUrls.moodboard),
            backgroundColor: 'red'
          });
        } finally {
          _this2.loading = false;
        }
      })();
    },

    tracking(_ref) {
      var _this3 = this;

      return _asyncToGenerator(function* () {
        let {
          ref,
          action,
          label,
          el
        } = _ref;
        let category = '';

        if (window.tc_vars.env_template === 'listproduct_keyword') {
          category = 'Search Page';
        }

        if (window.tc_vars.env_template === 'liste produits') {
          category = 'Categorie';
        }

        if (window.tc_vars.env_template === 'page produit') {
          category = 'FicheProduit';
        }

        const defaultLabel = "".concat(window.tc_vars.page_cat1 || '', "_").concat(window.tc_vars.page_cat3 || '', "_").concat(ref);

        _this3.$root.$emit('generic-tracking', el, {
          data: {
            event_category: category,
            event_action: action,
            event_label: label || defaultLabel
          }
        });
      })();
    },

    getWishlistItem(ref) {
      return this.items.find(e => e.product && e.product.reference === ref);
    }

  })
};